import { Breakpoint, Theme } from '@mui/material';
import { Components } from '@mui/material/styles';
import tokens from '@skodaflow/web-tokens/src/tokens.json';

const getGridSettings = (breakpoint: Breakpoint, narrow?: boolean) => {
  const grid = narrow ? tokens['flow-grid'].narrow : tokens['flow-grid'].default;
  switch (breakpoint) {
    case 'xs':
      return grid.find((i) => i.media === 'mobile');
    case 'sm':
      return grid.find((i) => i.media === 'mobile');
    case 'md':
      return grid.find((i) => i.media === 'tablet');
    case 'lg':
      return grid.find((i) => i.media === 'desktop');
    case 'xl':
      return grid.find((i) => i.media === 'desktop-xl');
  }
};

const getOffset = (breakpoint: Breakpoint, narrow?: boolean) => getGridSettings(breakpoint, narrow).style.offset;

export const getGutters = (breakpoint: Breakpoint, narrow?: boolean) => {
  const padding = getOffset(breakpoint, narrow);
  return padding ? { paddingLeft: `${+padding}px`, paddingRight: `${+padding}px` } : undefined;
};

const disabledGutters = {
  paddingLeft: 0,
  paddingRight: 0,
};

export const flowContainer: Components<Theme>['MuiContainer'] = {
  defaultProps: {
    maxWidth: false,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      [theme.breakpoints.up('xs')]: getGutters('xs'),
      [theme.breakpoints.up('sm')]: getGutters('sm'),
      [theme.breakpoints.up('md')]: getGutters('md'),
      [theme.breakpoints.up('lg')]: getGutters('lg'),
      [theme.breakpoints.up('xl')]: getGutters('xl'),
    }),
    disableGutters: ({ theme }) => ({
      [theme.breakpoints.up('xs')]: disabledGutters,
      [theme.breakpoints.up('sm')]: disabledGutters,
      [theme.breakpoints.up('md')]: disabledGutters,
      [theme.breakpoints.up('lg')]: disabledGutters,
      [theme.breakpoints.up('md')]: disabledGutters,
    }),
    maxWidthXs: ({ theme }) => ({
      [theme.breakpoints.up('xs')]: {
        maxWidth: theme.breakpoints.values.sm,
      },
    }),
    maxWidthSm: ({ theme }) => ({
      [theme.breakpoints.up('sm')]: {
        maxWidth: theme.breakpoints.values.md,
      },
    }),
    maxWidthMd: ({ theme }) => ({
      [theme.breakpoints.up('md')]: {
        maxWidth: theme.breakpoints.values.lg,
      },
    }),
    maxWidthLg: ({ theme }) => ({
      [theme.breakpoints.up('lg')]: {
        maxWidth: theme.breakpoints.values.xl,
      },
    }),
    maxWidthXl: ({ theme }) => ({
      [theme.breakpoints.up('xl')]: {
        maxWidth: theme.breakpoints.values.xl,
      },
    }),
  },
  variants: [],
};
